/* Tester egen state via document event */

import { IProduct } from "../model/product";

let callbackFuncs: Function[] = [];

function toggleItem(product: IProduct) {
	let currentCart = localStorage.getItem('cartsportsam') || '[]';
	let cart = JSON.parse(currentCart);
	const alreadyAdded = cart.find((item: IProduct) => item._id === product._id);
	if (alreadyAdded) {
		cart = cart.filter((item: IProduct) => item._id !== product._id);
	} else {
		cart.push(product);
	}
	localStorage.setItem('cartsportsam', JSON.stringify(cart));
	callbackFuncs.forEach(func => func());
}

function getCart(): IProduct[] {
	let currentCart = localStorage.getItem('cartsportsam') || '[]';
	return JSON.parse(currentCart);

}

function init(document: Document) {
	callbackFuncs = [];
	callbackFuncs.forEach(func => func());
}

export default {
	init,
	cartUpdated: (func: Function) => {
		callbackFuncs.push(func);
	},
	toggleItem,
	getCart
}